<template>
	<div
		@mousedown="onSelect(item)"
		@touchstart="onSelect(item)"
	>
		<div>{{ item.value }}</div>
		<div class="small">
			{{ item.data.address.value }}
		</div>
		<div class="small">
			ИНН {{ item.data.inn }} <span v-if="item.data.kpp"> / КПП {{ item.data.kpp }}</span>
		</div>
	</div>
</template>

<script>
import daDataMixin from '~/mixins/daDataMixin';

export default {
	mixins: [daDataMixin],
};
</script>
